import { z } from '@bonanza-social/toolkit/api';

export const MarketingPreferencesSchema = z.object({
  allowSMSMarketingTool: z.boolean(),
  allowEmailMarketingTool: z.boolean(),
  allowInboxMarketingTool: z.boolean().optional(),
  allowBigWinNotifications: z.boolean().optional(),
});

export const AccountMarketingSchema = z.object({
  marketingPreferences: MarketingPreferencesSchema.optional(),
});
